
import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import DOMPurify from 'dompurify';
interface UiBasic {
  id?: number;
  apropos?: string;
  travail?: string;
  don?: string;
  structuregestion?: string;
  financement?: string;
  carriere?: string;
  partenariat?: string;
  createdAt?: string;
  updatedAt?: string;
}


interface Site {
  id?: number;
  nom?: string;
  description?: string;
  email?: string;
  adresse?: string;
  tel1?: string;
  tel2?: string;
  tel3?: string;
  token?: string;
  about?: string;
  mission?: string;
  objectif?: string;
  politique?: string;
  condition?: string;
  logo?: string;
  logoFile?: File;
  facebook?: string;
  linkedin?: string;
  twitter?: string;
  youtube?: string;
  whatsapp?: string;
  createdAt?: string;
  updatedAt?: string;
}
export default function StructureGestion() {
  const [sites, setSites] = useState<Site[]>([]);
  const [basic, setBasic] = useState<UiBasic[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const fetchListBasic = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<UiBasic>('/fetch_info_basic_data');
      setBasic(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }



  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<Site>('/fetch_data_site');
      setSites(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    document.title = "Structure de gestion - Ouragan academy";
    fetchListBasic();
    fetchData();
  }, []);
  return (
    <div className='col-md-12 col-lg-12 col-sm-12 col-12'>

      {basic.length === 0 ? (
        <LoaderAndError
          loading={loading}
          error={error}
          onClearError={() => setError(null)}
        />
      ) : (
        basic.map((item, index) => (

          <div className="col-md-12" key={index}>

            <div className="container py-5">

              {/* Titre principal */}
              <div className="text-center mb-4">
                <h2 className="display-10 fw-bold">
                  <span className="text-primary">Structure</span> de Gestion
                </h2>
                <p className="text-muted text-center mb-5">
                  Une organisation claire et rigoureuse pour garantir un encadrement professionnel,
                  une gestion transparente et un accompagnement complet des jeunes basketteurs.
                </p>
              </div>

              {/* STRUCTURE ORGANISATIONNELLE */}
              <div className="row justify-content-center g-4">

                {/* Direction Générale */}
               
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-grey50">
                    <div className="icon mb-3 text-primary fs-1">
                      <i className="fas fa-user-tie"></i>
                    </div>
                    <h5 className="card-title fw-bold">Direction Générale</h5>
                    <p className="card-text text-muted">
                      Supervise l’ensemble des activités, porte la vision stratégique et assure
                      le développement global de l’Académie.
                    </p>
                  </div>
                </div>

                {/* Encadrement Sportif */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-grey50">
                    <div className="icon mb-3 text-primary fs-1">
                      <i className="fas fa-basketball"></i>
                    </div>
                    <h5 className="card-title fw-bold">Encadrement Sportif</h5>
                    <p className="card-text text-muted">
                      Regroupe les coachs, préparateurs physiques et responsables techniques
                      chargés de la formation quotidienne et de la performance des jeunes.
                    </p>
                  </div>
                </div>

                {/* Département Administratif */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-grey50">
                    <div className="icon mb-3 text-warning fs-1">
                      <i className="fas fa-folder-open"></i>
                    </div>
                    <h5 className="card-title fw-bold">Département Administratif</h5>
                    <p className="card-text text-muted">
                      Garantit la gestion financière, logistique et administrative,
                      ainsi que le support général aux différents programmes sportifs et éducatifs.
                    </p>
                  </div>
                </div>

                {/* Département Psychosocial */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-grey50">
                    <div className="icon mb-3 text-danger fs-1">
                      <i className="fas fa-heartbeat"></i>
                    </div>
                    <h5 className="card-title fw-bold">Encadrement Psychosocial</h5>
                    <p className="card-text text-muted">
                      Assure le soutien psychologique, l’accompagnement éducatif et la stabilité
                      émotionnelle des jeunes issus de zones en conflit.
                    </p>
                  </div>
                </div>

                {/* Monitoring & Evaluation */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-grey50">
                    <div className="icon mb-3 text-info fs-1">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <h5 className="card-title fw-bold">Suivi & Évaluation</h5>
                    <p className="card-text text-muted">
                      Mesure les performances sportives, l’impact social, la progression éducative
                      et garantit la qualité des programmes.
                    </p>
                  </div>
                </div>

                {/* Logistique & Infrastructure */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-grey50">
                    <div className="icon mb-3 text-secondary fs-1">
                      <i className="fas fa-warehouse"></i>
                    </div>
                    <h5 className="card-title fw-bold">Logistique & Infrastructures</h5>
                    <p className="card-text text-muted">
                      Gère les équipements, les terrains, les installations sportives
                      et assure la disponibilité des ressources matérielles.
                    </p>
                  </div>
                </div>

              </div>

              {/* CONTENU HTML DEPUIS LA BD */}
              <div className="col-lg-12 p-lg-12 mt-4 text-justify">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.structuregestion ?? '')
                  }}
                />
              </div>

            </div>
          </div>

        ))
      )}

    </div>


  )
}

